export const getVersion = (): string => {
  return import.meta.env.VITE_COMMIT_HASH || "dev-local";
};

export const getVersionDisplayText = (): string => {
  const version = getVersion();
  return version === "dev-local" ? "Development" : `${version.substring(0, 7)}`;
};
